export const makeUserDataCardConfigKey = (dashboardId: string, dataCardId: string) => `${dashboardId}_${dataCardId}`;
